import { flowTypes } from '../components/billing-product-entry/constant';
import isEmpty from "lodash-es/isEmpty";

export const gaFlowTypes = (options = {}) => {
  const trackingPlanName = options?.trackingPlanName;

  return {
    [flowTypes.buyNow]: 'Direct Purchase',
    [flowTypes.basic2pro]: 'Free to Paid Upgrade',
    [flowTypes.edit]: `${trackingPlanName} edit`,
    [flowTypes.add2cart]: `${trackingPlanName} new add-ons`,
    [flowTypes.pro2biz]: 'billing upgrade paid2paid',
    [flowTypes.trial2paid]: 'free trial upgrade',
    [flowTypes.addTrial]: 'add free trial',
  };
};

// customizable raw payload
export const EventTracking = (payload) => {
  if (typeof window !== 'undefined' && Array.isArray(window?.dataLayer) && !isEmpty(payload)) {
    window.dataLayer.push(payload);
  }
};
